export default __webpack_public_path__ + "static/article-real-stories-saving-spending-lending-aimee-85db68da15e5005c35875822a0155c0c.jpg";